import { Styles } from "../../../../config"

const styles = {
	container(mobileOnly) {
		return {
			padding: { zero: "15px 10px", xs2: "30px 25px" },
			width: "100%",
			maxWidth: mobileOnly ? null : "500px",
			justifyContent: "center",
			alignItems: "center",
			border: `1px solid ${Styles.Color.primary75}`,
			borderRadius: "10px"
		}
	},

	row: {
		padding: "0px 10px",
		width: "100%",
		justifyContent: "center"
	},

	label: {
		width: "50%",
		fontSize: { zero: "0.9rem", xs2: "1rem" },
		fontWeight: Styles.FontSize.t4.weight,
		color: Styles.Color.primary
	},

	value: {
		width: "50%",
		fontSize: { zero: "0.875rem", xs2: "1rem" },
		fontWeight: Styles.FontSize.t6.weight,
		color: Styles.Color.primary
	},

	divider: {
		width: "100%",
		borderTop: `1px solid ${Styles.Color.primary50}`,
		borderBottom: "none"
	},

	spacing: {
		height: "50px"
	}
}

export default styles
